module.exports = __webpack_public_path__ + "img/chart-2779164_1920.f3c98ed3.jpg";